import { h, render } from 'preact';

import './tabs-component'
import './video-modal'
import './product-information.css'

export default (element, data) => {

  const init = () => {
  };

  init();
};
